module.exports = __webpack_public_path__ + "img/Modernisme_Tanker_i_tida1.d0565ab7.jpg";